export default ({
    request
  }) => ({
    SYS_LOCALES_LIST(data = {
        dictType: 'Internationalization'
    }) {
      return request({
        url: '/digitalCenter/common/dict/system',
        method: 'post',
        data
      })
    },
    SYS_LOCALES_PAGE(data = {}) {
      return request({
        url: '/digitalCenter/common/dict/formDisplayText',
        method: 'post',
        data
      })
    }
  })